import * as React from "react";
import { cn } from "@/lib/utils";

const buttonVariants = {
  variant: {
    default: "bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-sm transition-colors duration-200",
    outline: "border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 rounded-full shadow-sm transition-colors duration-200",
    ghost: "hover:bg-gray-100 text-gray-700 rounded-full transition-colors duration-200",
    link: "text-blue-500 hover:underline underline-offset-4",
    destructive: "bg-red-500 hover:bg-red-600 text-white rounded-full shadow-sm transition-colors duration-200",
  },
  size: {
    default: "h-10 px-6 py-2",
    sm: "h-8 px-4 text-sm",
    lg: "h-12 px-8",
    icon: "h-10 w-10",
  },
};

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof buttonVariants.variant;
  size?: keyof typeof buttonVariants.size;
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const baseStyles = "inline-flex items-center justify-center font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
    
    return (
      <button
        className={cn(
          baseStyles,
          buttonVariants.variant[variant],
          buttonVariants.size[size],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };